import { render, staticRenderFns } from "./SuccessForm.vue?vue&type=template&id=00d52789&scoped=true&"
import script from "./SuccessForm.vue?vue&type=script&lang=js&"
export * from "./SuccessForm.vue?vue&type=script&lang=js&"
import style0 from "./SuccessForm.vue?vue&type=style&index=0&id=00d52789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d52789",
  null
  
)

export default component.exports